import DocumentsHome from "./document-home.jsx";
import CaseDocuments from "./case-documents.jsx";
import NewCaseDocuments from "./add-case-documents.jsx";

export { CaseDocuments, NewCaseDocuments };
export default DocumentsHome;